import buildBooleanFilter from '../buildBooleanFilter'

const MyBidsFilter = buildBooleanFilter({
  key: 'myBids',
  filterTitle: 'my_bids',
})

export default MyBidsFilter
